/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ar_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What if the height isn't a whole number?`)
};

const es_ar_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué pasa si la altura no es un número entero?`)
};

const de_ar_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was, wenn die Höhe keine ganze Zahl ist?`)
};

const nl_ar_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat als de hoogte geen heel getal is?`)
};

const fr_ar_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Et si la hauteur n'est pas un nombre entier ?`)
};

const it_ar_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E se l'altezza non è un numero intero?`)
};

const pt_br2_ar_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E se a altura não for um número inteiro?`)
};

const pt_ar_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E se a altura não for um número inteiro?`)
};

const ja_ar_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`高さが整数でない場合はどうなりますか？`)
};

const zh_ar_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如果高度不是整数怎么办?`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ar_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ar_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ar_faq2_q", locale)
	if (locale === "en") return en_ar_faq2_q(inputs)
	if (locale === "es") return es_ar_faq2_q(inputs)
	if (locale === "de") return de_ar_faq2_q(inputs)
	if (locale === "nl") return nl_ar_faq2_q(inputs)
	if (locale === "fr") return fr_ar_faq2_q(inputs)
	if (locale === "it") return it_ar_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_ar_faq2_q(inputs)
	if (locale === "pt") return pt_ar_faq2_q(inputs)
	if (locale === "ja") return ja_ar_faq2_q(inputs)
	return zh_ar_faq2_q(inputs)
};